export enum EmailDomainType {
  NAVER = "naver.com",
  DAUM = "daum.net",
  NATE = "nate.com",
  HOTMAIL = "hotmail.com",
  YAHOO = "yahoo.com",
  EMPAS = "empas.com",
  KOREA = "korea.com",
  DREAMWIZ = "dreamwiz.com",
  GMAIL = "gmail.com",
  CUSTOM = "직접 입력",
}

export const emailDomainTypeDisplayNames = {
  [EmailDomainType.NAVER]: "naver.com",
  [EmailDomainType.DAUM]: "daum.net",
  [EmailDomainType.NATE]: "nate.com",
  [EmailDomainType.HOTMAIL]: "hotmail.com",
  [EmailDomainType.YAHOO]: "yahoo.com",
  [EmailDomainType.EMPAS]: "empas.com",
  [EmailDomainType.KOREA]: "korea.com",
  [EmailDomainType.DREAMWIZ]: "dreamwiz.com",
  [EmailDomainType.GMAIL]: "gmail.com",
  [EmailDomainType.CUSTOM]: "직접 입력",
};
